import Swiper from 'swiper/swiper-bundle';

export class WbSlider {
  constructor() {}

  init() {
    return new Promise((resolve, reject) => {
      this.initSlider();
      this.initSliderGoTo();
      resolve();
    });
  }

  initSlider() {
    for (const carousel of document.querySelectorAll('.swiper')) {
      const parentElement = carousel.closest('.swiper-parent');
      const {
        hasNavigation,
        hasPagination,
        isAutoplay,
        lgBreakpoint,
        lgSpaceBetween,
        mdBreakpoint,
        mdSpaceBetween,
        smBreakpoint,
        smSpaceBetween,
        speed,
      } = carousel.dataset;

      const carouselParams = {
        speed,
        spaceBetween: parseFloat(smSpaceBetween),
        slidesPerView: parseFloat(smBreakpoint),
        breakpoints: {
          768: {
            spaceBetween: parseFloat(mdSpaceBetween),
            slidesPerView: parseFloat(mdBreakpoint),
          },
          1280: {
            spaceBetween: parseFloat(lgSpaceBetween),
            slidesPerView: parseFloat(lgBreakpoint),
          },
        },
      };
      if (isAutoplay) {
        Object.assign(carouselParams, {
          autoplay: {
            delay: 5000,
          },
        });
      }
      if (hasNavigation && parentElement.querySelector('.swiper-navigation')) {
        
        Object.assign(carouselParams, {
          navigation: {
            nextEl: parentElement.querySelector('.swiper-button-next'),
            prevEl: parentElement.querySelector('.swiper-button-prev'),
          },
        });
      }
      if (hasPagination && carousel.querySelector('.swiper-pagination')) {
        Object.assign(carouselParams, {
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + (index + 1) + '</span>';
            },
          },
        });
      }

      new Swiper(carousel, carouselParams);
    }
  }

  initSliderGoTo() {
    for (const modalCarousel of document.querySelectorAll('.carousel-open-modal')) {
      modalCarousel?.addEventListener('click', e => {
        const ele = e?.currentTarget;
        const { slideNumber, src } = ele.dataset;
        if (slideNumber) {
          window?.setTimeout(() => {
            document
              .querySelector(src)
              ?.querySelector('.swiper')
              ?.swiper
              ?.slideTo(slideNumber);
          }, 500);
        }
      });
    }
  }
}
